import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "src/app/core/services/app.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-general-setup",
	templateUrl: "./general-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class GeneralSetupComponent implements OnInit, OnDestroy {
	changesToSave: boolean = false;
	changesToOoMenuConfig: boolean = false;

	viewModeOptions: {
		label: string;
		mode: number;
		faPrefix: string;
		faIcon: string;
	}[] = [
		{
			label: "Store",
			mode: 0,
			faIcon: "store",
			faPrefix: "far",
		},
		{
			label: "Messaging",
			mode: 1,
			faIcon: "comment-lines",
			faPrefix: "far",
		},
		{
			label: "Order Handling",
			mode: 2,
			faIcon: "hand-holding-box",
			faPrefix: "far",
		},
		{
			label: "Display",
			mode: 3,
			faIcon: "desktop",
			faPrefix: "far",
		},
		{
			label: "POS",
			mode: 4,
			faIcon: "cash-register",
			faPrefix: "far",
		},
	];

	viewMode: number = 0;

	constructor(public app: AppService, public imgCrop: ImageCropperService, public venueSvc: OOVenueService, private router: Router) {}

	ngOnInit(): void {}

	ngOnDestroy() {
		if (this.changesToSave) {
			this.app.confirmation.confirm({
				message: `You have unsaved changes. Save?`,
				accept: async () => {
					this.onSave();
				},
				reject: async () => {
					this.app.confirmation.close();
				},
			});
		}
	}

	onSave() {
		this.venueSvc.ooVenueSave();
		this.changesToSave = false;
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Online ordering settings saved successfully.` });
		if (this.changesToOoMenuConfig) {
			this.venueSvc.ooMenuConfigSave(this.venueSvc.ooMenuConfig);
			this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Saved Venue POS Config` });
		}
	}
}
